<template>
  <div class="login-container">
    <el-card class="login-card" shadow="hover">
      <h2 class="login-title">Сменить пароль</h2>
      <el-form :model="form" :rules="rules" ref="formRef" @submit.prevent="handleReset">
        <el-form-item prop="username">
          <el-input
              v-model="form.username"
              placeholder="Username"
              prefix-icon="el-icon-user"
              autocomplete="off"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
              v-model="form.password"
              type="password"
              placeholder="Введите старый пароль"
              prefix-icon="el-icon-lock"
              autocomplete="off"
          />
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-input
              v-model="form.newPassword"
              type="password"
              placeholder="Введите новый пароль"
              prefix-icon="el-icon-lock"
              autocomplete="off"
          />
        </el-form-item>
        <el-form-item prop="confirmNewPassword">
          <el-input
              v-model="form.confirmNewPassword"
              type="password"
              placeholder="Введите новый пароль еще раз"
              prefix-icon="el-icon-lock"
              autocomplete="off"
          />
        </el-form-item>
        <br>
        <el-form-item>
          <el-button v-if="!loading" type="primary" @click="handleReset" block>Сохранить новый пароль</el-button>
          <el-button v-else disabled>Загрузка...</el-button>
        </el-form-item>
      </el-form>
      <p v-if="message" class="error-message">{{ message }}</p>
    </el-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import {ElMessage, FormInstance} from "element-plus";
import { useRouter } from "vue-router";
import { ResetPasswordRequest } from "@/types/auth";
import { reset } from "@/services/userService";

export default defineComponent({
  name: "ResetPasswordView",
  setup() {
    const formRef = ref<FormInstance | null>(null);
    const form = ref({
      username: "",
      password: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    const message = ref("");
    const router = useRouter();
    const loading = ref(false);

    const rules = {
      username: [
        { required: true, message: "Поле username обязательно", trigger: "blur" },
      ],
      password: [
        { required: true, message: "Введите старый пароль", trigger: "blur" },
      ],
      newPassword: [
        { required: true, message: "Введите новый пароль", trigger: "blur" },
        { min: 6, message: "Пароль должен содержать минимум 6 символов", trigger: "blur" },
      ],
      confirmNewPassword: [
        { required: true, message: "Подтвердите новый пароль", trigger: "blur" },
        {
          validator: (rule: any, value: any, callback: any) => {
            if (value !== form.value.newPassword) {
              callback(new Error("Пароли не совпадают"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    };

    const handleReset = () => {
      if (formRef.value) {
        formRef.value.validate(async (valid) => {
          if (valid) {
            const requestData: ResetPasswordRequest = {
              username: form.value.username,
              password: form.value.password,
              newPassword: form.value.newPassword,
              confirmNewPassword: form.value.confirmNewPassword,
            };
            try {
              loading.value = true;
              await reset(requestData).then(() => {
                loading.value = false;
                ElMessage.success("Пароль успешно изменен");
                router.push("/login");
              }, (error) => {
                loading.value = false;
                message.value = error.response.data;
                ElMessage.error(error.response.data);
              });
            } catch (error) {
              message.value = "Ошибка при смене пароля. Попробуйте еще раз.";
              ElMessage.error(message.value);
              loading.value = false;
            }
          } else {
            ElMessage.warning("Пожалуйста, заполните все поля корректно.");
            loading.value = false;
          }
        });
      }
    };

    return {
      form,
      formRef,
      rules,
      message,
      loading,
      handleReset,
    };
  },
});
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  padding: 30px;
}

.login-title {
  text-align: center;
  margin-bottom: 20px;
}

.error-message {
  color: red;
  margin-top: 15px;
  text-align: center;
}
</style>
